import React, { useState, useCallback } from "react";
import { Divider, Form, Modal, Typography } from "antd";
import { useIntl } from "react-intl";

import {
  put,
  checkResponse,
  checkHttpStatus,
  CLIENT_PLACEHOLDER,
} from "../../../modules/httpFunctions";
import InputItem from "../../app/generic/inputItem";
import { handleError } from "../../../modules/errorLogger";
import { error, success } from "../../../modules/messages";

const UserAddForm = ({ form, visible, loadUsers, onSetVisible }) => {
  const intl = useIntl();
  const { getFieldDecorator } = form;
  const formItemLayout = { colon: false };

  const [loading, setLoading] = useState();
  const handleSubmit = useCallback(() => {
    form.validateFields((err, values) => {
      if (!err) {
        setLoading(true);
        put(`client/${CLIENT_PLACEHOLDER}/user/${values.username}/add`, values)
          .then((r) => {
            setLoading(false);
            if (checkHttpStatus(r) && checkResponse(r)) {
              success(
                r.data.message ||
                  intl.formatMessage({
                    id: "user.saved",
                    defaultMessage: "Uživatel byl úspěšně uložen.",
                  })
              );
              onSetVisible(false);
              loadUsers();
            } else {
              error(
                (r.data && r.data.message) ||
                  intl.formatMessage({
                    id: "user.saveError",
                    defaultMessage: "Při ukládání uživatele nastala chyba!",
                  }),
                10
              );
            }
          })
          .catch((err) => {
            setLoading(false);
            error(
              intl.formatMessage({
                id: "user.saveError",
                defaultMessage: "Při ukládání uživatele nastala chyba!",
              }),
              10
            );
            handleError(err);
          });
      }
    });
  }, [form, intl, loadUsers, onSetVisible]);

  const handleCancel = useCallback(() => {
    onSetVisible(false);
  }, [onSetVisible]);

  return (
    <Modal
      width={500}
      visible={visible}
      onOk={handleSubmit}
      cancelText={intl.formatMessage({
        id: "messages.close",
        defaultMessage: "Zavřít",
      })}
      okText={intl.formatMessage({
        id: "user.add",
        defaultMessage: "Přidat uživatele",
      })}
      onCancel={handleCancel}
      confirmLoading={loading}
      title={intl.formatMessage({
        id: "user.add.title",
        defaultMessage: "Přidání stávajícího uživatele",
      })}
    >
      <Typography.Text strong>
        {intl.formatMessage({
          id: "user.add.info",
          defaultMessage: "Přidání stávajícího uživatele",
        })}{" "}
      </Typography.Text>
      <Divider />
      <Form {...formItemLayout}>
        <InputItem
          fieldName="username"
          label={intl.formatMessage({
            id: "user.username",
            defaultMessage: "Uživatelské jméno",
          })}
          message={intl.formatMessage({
            id: "user.emptyUserName",
            defaultMessage: "Zadejte uživatelské jméno!",
          })}
          formItemLayout={formItemLayout}
          getFieldDecorator={getFieldDecorator}
        />
      </Form>
    </Modal>
  );
};

export default Form.create()(UserAddForm);
